import { ProviderType } from '@dcl/schemas';
import { getConfiguration } from '../configuration';
import { AbstractConnector } from './AbstractConnector';
export class MagicConnector extends AbstractConnector {
    constructor(desiredChainId) {
        super({ supportedChainIds: getConfiguration()[ProviderType.MAGIC].chains });
        this.activate = async () => {
            this.magic = await this.buildMagicInstance(this.chainId);
            const isLoggedIn = await this.magic.user.isLoggedIn();
            if (!isLoggedIn) {
                throw new Error('Magic: user isn\'t logged in');
            }
            const provider = await this.getProvider();
            const accounts = (await provider.request({ method: 'eth_accounts' }));
            this.account = accounts[0] ?? null;
            return {
                provider,
                chainId: this.chainId,
                account: this.account
            };
        };
        this.getProvider = async () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            const provider = await this.magic.wallet.getProvider();
            return { ...provider, request: new Proxy(provider.request, {
                    apply: async (target, _thisArg, argumentsList) => {
                        // Magic doesn't support the "wallet_switchEthereumChain" method, we need to re-instantiate the Magic instance
                        if (argumentsList[0]?.method === 'wallet_switchEthereumChain') {
                            try {
                                const chainId = parseInt(argumentsList[0]?.params[0]?.chainId, 16);
                                if (this.supportedChainIds && !this.supportedChainIds.includes(chainId)) {
                                    return {
                                        code: 2020202,
                                        message: 'Unsupported Magic ChainId'
                                    };
                                }
                                this.magic = await this.buildMagicInstance(chainId);
                                this.emitUpdate({ chainId });
                                return null;
                            }
                            catch (error) {
                                return {
                                    code: 2020201,
                                    message: 'Error changing the Magic ChainId'
                                };
                            }
                        }
                        return target.bind(provider)(...argumentsList);
                    }
                }) };
        };
        this.getChainId = async () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            return this.chainId;
        };
        this.getAccount = async () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            return this.account;
        };
        this.deactivate = () => undefined;
        this.buildMagicInstance = async (chainId) => {
            const { Magic } = await import('magic-sdk');
            const { OAuthExtension } = await import('@magic-ext/oauth');
            const magicConfiguration = getConfiguration()[ProviderType.MAGIC];
            return new Magic(magicConfiguration.apiKey, {
                extensions: [new OAuthExtension()],
                network: {
                    rpcUrl: magicConfiguration.urls[chainId],
                    chainId: chainId
                }
            });
        };
        this.chainId = desiredChainId;
        this.account = null;
    }
    close() {
        if (!this.magic) {
            throw new Error('Magic: instance was not initialized');
        }
        return this.magic.user.logout();
    }
}
//# sourceMappingURL=MagicConnector.js.map